export default __webpack_public_path__ + "static/media/green-loan-principles.c2425718.jpg";